import { render, staticRenderFns } from "./FormBuildersList.vue?vue&type=template&id=0e3483e0&scoped=true"
import script from "./FormBuildersList.vue?vue&type=script&lang=js"
export * from "./FormBuildersList.vue?vue&type=script&lang=js"
import style0 from "./FormBuildersList.vue?vue&type=style&index=0&id=0e3483e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3483e0",
  null
  
)

export default component.exports